import FIELDS from './field'
import * as FIELD_LISTS from './fieldLists'
import APPNAMES from './appNames'
import FOOTERLINKS, { FAQs } from './footerLinks'
import STEPS from './steps'
import TESTS from './tests'
import LOGOS from './logos'
import USA from './USA'
import THEME from './theme'

const DEFAULT = {
  FIELDS,
  FIELD_LISTS,
  APPNAMES,
  FOOTERLINKS,
  FAQs,
  STEPS,
  TESTS,
  LOGOS,
  USA,
  THEME,
}

export default DEFAULT
